import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MastersTable from "@/components/tables/masters/MastersTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MasterTableView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MastersTable))
}
}

})